export default "__VITE_ASSET__JDc2WE74__"